/**
 * 覆盖翻译平台自动同步的数据，一般用于紧急文案缺失的问题，避免delay
 * 正常情况一定要按标准流程，让产品翻译平台提翻译需求
 *
 * 这里的 UI Key 是人为构造的，与翻译平台自动生成的保持一致便可
 * 为便于检索，可以统一以 _AAAA 后缀结尾
 */
export default {
  'zh-CN': {
    // 'FoodB_I_Network_Error_AAAA': '网络连接失败，请检查网络设置',
    'FoodOpB_1_Information_gathering_pIHo_other_FE_BDAPP': '信息收集',
    'FoodOpB_is_high_price': '高价',
    'FoodOpB_is_high_price_store': '高价店',
    'FoodOpB_is_quality_shop': '优质店铺',
    'FoodOpB_is_quality_store': '优质店',
    'FoodOpB_my_add_new_bizopp': '我新增的商机',
    'FoodB_page_ErfH_yeAb': '请上传相关拜访的证明，例如：聊天、会议、邮件截图等',
  },
  'en-US': {
    // 'FoodB_I_Network_Error_AAAA': 'Network connection failed, please check the network settings',
    'FoodOpB_1_Information_gathering_pIHo_other_FE_BDAPP': 'Collect Store Info',
    'FoodOpB_is_high_price': 'Higher',
    'FoodOpB_is_high_price_store': 'Higher Price Shop',
    'FoodOpB_is_quality_shop': 'Quality shop',
    'FoodOpB_is_quality_store': 'Quality store',
    'FoodB_Company_register_Number_em': 'Company registration number',
    'FoodOpB_my_add_new_bizopp': 'My Leads',
    'FoodB_page_ErfH_yeAb': 'Please upload proof of relevant visits, such as screenshots of chats, meetings, emails, etc.',
  },
  'es-MX': {
    // 'FoodB_I_Network_Error_AAAA': 'Falló la conexión de red, verifique la configuración de red',
    'FoodOpB_1_Information_gathering_pIHo_other_FE_BDAPP': 'Recopilación de información',
    'FoodOpB_is_high_price': 'Alta',
    'FoodOpB_is_high_price_store': 'Alta prezo butiko',
    'FoodOpB_is_quality_shop': 'Tienda de calidad',
    'FoodOpB_is_quality_store': 'Tienda de calidad',
    'FoodB_Company_register_Number_em': 'Número de registro',
    'FoodOpB_my_add_new_bizopp': 'Mis prospectos',
    'FoodB_page_ErfH_yeAb': 'Por favor, cargue pruebas de visitas relevantes, como capturas de pantalla de chats, reuniones, correos electrónicos, etc.',
  },
  'ja-JP': {
    // 'FoodB_I_Network_Error_AAAA': 'インターネット接続はありません。インターネットの設定を確認してください',
    'FoodOpB_1_Information_gathering_pIHo_other_FE_BDAPP': '情報収集',
    'FoodOpB_is_high_price': '高級',
    'FoodOpB_is_high_price_store': '高級店',
    'FoodOpB_is_quality_shop': '優良店舗',
    'FoodOpB_is_quality_store': '上質の店',
    'FoodB_Company_register_Number_em': 'Número de registro',
    'FoodOpB_my_add_new_bizopp': '私が追加したターゲット店舗',
    'FoodB_page_ErfH_yeAb': 'Please upload proof of relevant visits, such as screenshots of chats, meetings, emails, etc.',
  },
  'pt-BR': {
    // 'FoodB_I_Network_Error_AAAA': 'Conexão falhou, favor verificar as configurações de rede',
    'FoodOpB_1_Information_gathering_pIHo_other_FE_BDAPP': 'Coleta de informações',
    'FoodOpB_is_high_price': 'Loja',
    'FoodOpB_is_high_price_store': 'Loja de alto preço',
    'FoodOpB_is_quality_shop': 'Loja de qualidade',
    'FoodOpB_is_quality_store': 'Armazenamento de qualidade',
    'FoodB_Company_register_Number_em': 'Número de registro',
    'FoodOpB_my_add_new_bizopp': 'Meus leads',
    'FoodB_page_ErfH_yeAb': 'Envie comprovantes de visitas relevantes, como capturas de tela de bate-papos, reuniões, e-mails, etc.',
  },
}